// cleanSlate overflow menus — trigger click delegate.
//
// base actionsGroup.tpl renders a menu as a <button data-zit-menu-trigger> immediately
// followed by its <ul role="menu" data-zit-menu="true"> panel. bootstrap5 / metronic_8
// open that through their framework's own document-level dropdown handler; cleanSlate
// has none, so (per the behaviour contract's rule for delegate-less tiers) this is the
// frameworkless replacement, the sibling of scripts/collapse.js. The panel itself —
// fixed positioning, outside-click / scroll close — is the submenu behaviour's job;
// this delegate only decides when to open and close it.
//
// Scope: only the actionsGroup shape (a trigger whose next sibling is the menu panel)
// and never a component-owned trigger. selectSearchable also marks its input holder
// with data-zit-menu-trigger, but wires its own menu (it is a component subelement),
// and the tags widget builds a panel with no trigger attribute at all — both are left
// alone. One delegated listener covers menus inserted after boot (XHR-loaded lists).
export default function initMenu(hm) {
    document.addEventListener('click', function (event) {
        // 1) A click on a menu trigger opens or closes its panel.
        const trigger = event.target.closest('[data-zit-menu-trigger]:not([data-zit-subelement-for])');

        if (trigger) {
            const menuEl = trigger.nextElementSibling;

            if (!menuEl || !menuEl.matches('[data-zit-menu="true"]')) {
                return;
            }

            // the trigger is a <button> inside mainForm: never let it submit the page
            event.preventDefault();

            const instance = hm.behaviors.submenu.get(menuEl);

            if (instance === null) {
                return;
            }

            // the submenu adapter marks an open panel with the shown class
            if (menuEl.classList.contains('zit-cs-menu-shown')) {
                instance.hide();
            } else {
                instance.show(trigger);
            }

            return;
        }

        // 2) A click on a row of an open actions menu closes it. This listener runs in
        // the bubble phase on document, so the row's own action handler has already
        // run by the time the panel is hidden.
        const item = event.target.closest('[role="menu"][data-zit-menu="true"] [role="menuitem"]');

        if (item) {
            const menuEl = item.closest('[data-zit-menu="true"]');
            const instance = hm.behaviors.submenu.get(menuEl);

            if (instance !== null) {
                instance.hide();
            }
        }
    });
}
